import DefaultImg from "../Resources/img/default.png";

export default function ImageUrl(personImg, config) {
	let profilePic;
	if(personImg && personImg !== "default.png") {
		profilePic = {
			uri: config.image_cdn + personImg
		};
	} else {
		profilePic = DefaultImg;
	}
	return profilePic;
}
